<template>
    <div>
        <h1>Objednávka poukazu</h1>
        <ssv-order-header-gift-card/>
        <ssv-order-beneficiary-information-container ref="beneficiaryInformation"/>
        <div class="input-item">
            <label class="checkbox" for="anotherMailingAddress">
                <input type="checkbox" class="checkbox__native" id="anotherMailingAddress"
                       v-model="displayBillingInformation"> Chci zadat fakturační údaje
                <span class="checkbox__control"></span>
            </label>
        </div>
        <ssv-order-billing-information-container ref="billingInformation" v-if="displayBillingInformation"/>
        <ssv-order-contact-information-container required extended ref="contactInformation" :same-participant="false"/>
        <ssv-order-note/>
        <ssv-order-price-container/>
    </div>
</template>

<script>
    import SsvOrderBillingInformationContainer from '../billing-information/BillingInformationContainer';
    import SsvOrderContactInformationContainer from '../contact-information/ContactInformationContainer';
    import SsvOrderPriceContainer from '../price/PriceContainer';
    import SsvOrderBeneficiaryInformationContainer from '../beneficiary-information/BeneficiaryInformationContainer';
    import SsvOrderNote from '../parameters/OrderNote';
    import SsvOrderHeaderGiftCard from '../header/HeaderGiftCard';

    export default {
        name:       'SsvOrderGiftCard',
        components: {
            SsvOrderHeaderGiftCard,
            SsvOrderNote,
            SsvOrderBeneficiaryInformationContainer,
            SsvOrderPriceContainer,
            SsvOrderContactInformationContainer,
            SsvOrderBillingInformationContainer
        },
        data() {
            return {
                displayBillingInformation: false,
            }
        },
        methods:    {
            validate() {
                if (this.displayBillingInformation) {
                    this.$refs.billingInformation.validate();
                }
                this.$refs.beneficiaryInformation.validate();
                this.$refs.contactInformation.validate();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/order/GiftCard.vue